import React from 'react';

import './ContactBox.scss';
import Icon from 'Core/Components/Icon';
import ContactBlock from 'Core/Components/ContactBlock';
import TextBox from 'RLX/Forms/TextBox';
import { ListFieldItem } from 'RLX/Forms/ListField';

class ContactBox extends ListFieldItem {
  constructor (props) {
    super(props);
    this.getFields = this.getFields.bind(this);
    this.propertyUpdaterFactory = this.propertyUpdaterFactory.bind(this);
  }

  getClassName () {
    return 'ContactBox';
  }

  renderPreview () {
    const { contact } = this.props;
    return (
      <div className="ContactBox-PreviewWrapper">
        <strong>Preview</strong>
        <div className="ContactBox-Preview">
          <ContactBlock contact={contact}/>
        </div>
      </div>
    );
  }

  getFields () {
    const { contact } = this.props;
    const { propertyUpdaterFactory } = this;
    return [
      {
        label: 'Name',
        icon: 'user-o',
        value: contact.name,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('name', contact)
      },
      {
        label: 'Phone',
        icon: 'mobile',
        value: contact.phone,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('phone', contact)
      },
      {
        label: 'Street',
        icon: 'map-o',
        value: contact.street,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('street', contact)
      },
      {
        label: 'Street Line 2',
        icon: 'map-o',
        value: contact.street2,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('street2', contact)
      },
      {
        label: 'City / ZIP',
        icon: 'map-marker',
        value: contact.city,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('city', contact)
      },
      { content: <hr/> },
      {
        label: 'Link to URL',
        icon: 'link',
        value: contact.link,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('link', contact)
      },
      {
        label: 'Link Text',
        icon: 'external-link-square',
        value: contact.linkLabel,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('linkLabel', contact)
      },
      { content: <hr/> },
      {
        label: 'Email Address',
        icon: 'envelope-o',
        value: contact.email,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('email', contact)
      },
      {
        label: 'Email Label',
        icon: 'envelope',
        value: contact.emailLabel,
        type: 'text',
        className: 'half',
        onChange: propertyUpdaterFactory('emailLabel', contact)
      }
    ];
  }
};

export default ContactBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ContactBox/ContactBox.jsx